/**
 * "Let the assistant act for a signed-in user" — Guides section (ADR-0074).
 * Composes end-user authentication + the action-confirmation / step-up gate. Kept
 * aligned with the auth pages' hedged language: the assistant acts as the signed-in
 * user, scoped to their permissions, with confirmation before sensitive actions.
 */
import type { DocPageContent } from '../types';

export const GUIDES_ACT_AS_USER_PAGE: DocPageContent = {
  slug: 'guides/act-as-user',
  titleKey: 'docs.guides.actAsUser.title',
  descriptionKey: 'docs.guides.actAsUser.description',
  blocks: [
    { kind: 'paragraph', textKey: 'docs.guides.actAsUser.lead' },

    { kind: 'heading', level: 2, id: 'how', textKey: 'docs.guides.actAsUser.how.heading' },
    { kind: 'paragraph', textKey: 'docs.guides.actAsUser.how.body' },
    {
      kind: 'list',
      itemKeys: [
        'docs.guides.actAsUser.how.item.identity',
        'docs.guides.actAsUser.how.item.scope',
        'docs.guides.actAsUser.how.item.confirm',
      ],
    },

    { kind: 'heading', level: 2, id: 'steps', textKey: 'docs.guides.actAsUser.steps.heading' },
    {
      kind: 'steps',
      steps: [
        {
          titleKey: 'docs.guides.actAsUser.step.identify.title',
          textKey: 'docs.guides.actAsUser.step.identify.text',
        },
        {
          titleKey: 'docs.guides.actAsUser.step.endpoints.title',
          textKey: 'docs.guides.actAsUser.step.endpoints.text',
        },
        {
          titleKey: 'docs.guides.actAsUser.step.confirm.title',
          textKey: 'docs.guides.actAsUser.step.confirm.text',
        },
        {
          titleKey: 'docs.guides.actAsUser.step.test.title',
          textKey: 'docs.guides.actAsUser.step.test.text',
        },
      ],
    },
    {
      kind: 'callout',
      tone: 'important',
      titleKey: 'docs.guides.actAsUser.safety.title',
      textKey: 'docs.guides.actAsUser.safety.body',
      links: {
        stepup: {
          target: { docSlug: 'auth/step-up' },
          labelKey: 'docs.guides.actAsUser.safety.link',
        },
      },
    },

    { kind: 'heading', level: 2, id: 'next', textKey: 'docs.common.nextSteps' },
    {
      kind: 'cardGrid',
      cards: [
        {
          titleKey: 'docs.guides.actAsUser.related.endUser.title',
          textKey: 'docs.guides.actAsUser.related.endUser.text',
          to: { docSlug: 'auth/end-user-auth' },
        },
        {
          titleKey: 'docs.guides.actAsUser.related.endpoints.title',
          textKey: 'docs.guides.actAsUser.related.endpoints.text',
          to: { docSlug: 'dashboard/custom-endpoints' },
        },
      ],
    },
  ],
};
